<template>
    <div :class="[$style.__register__online]" >
       <h5>{{ $t("messages.offline") }}</h5>
       <p :class="[$style.__intro]" v-html="$t('messages.intro')"></p>
       <form :class="['form-horizontal', $style.chat__form]" @submit="checkForm" :id="'formLiveChat'">
            <InputName v-model="name" @change="getGender" ></InputName>
            <InputEmail v-model="email"></InputEmail>
            <div class="row-margin bdr-radius">
                <div class="input-comment">	
                    <textarea 
                        autofocus="autofocus" 
                        data-focus="data-focus"
                        v-model="msg" 
                        class="textarea" 
                        rows="2" 
                        :placeholder="[this.$t('textarea.send')]"
                     
                        @keyup="checkWhiteSpace"
                    ></textarea>
                </div>
                <div :class="[$style.__chat__footer]">
                    <div :class="[$style.__chat__action]">
                       
                    </div>
                </div>
            </div>
            <ErrorList :errors="errors"></ErrorList>
            <div :class="['row-livechat', 'mt-2']">
                <ButtonSubmit></ButtonSubmit>
                <ButtonCancel @parentFunction="cancelButton"></ButtonCancel>
            </div>
       </form>
    </div>
</template>


<script>
    import InputName from '../blocks/InputName';
    import InputEmail from '../blocks/InputEmail';
    import ButtonSubmit from '../blocks/ButtonSubmit';
    import ButtonCancel from '../blocks/ButtonCancel';
    import ErrorList from '../blocks/ErrorList';
    import Validator from '@/functions/Validator';
    import EventBus from '@/functions/EventBus'

    let validator = new Validator;

    export default {
        props : {
            nameMemory : {
                type : String,
                default : ''
            },
           
        },
        data () {
            return {
                name: '',
                email : '',
                gender : '1',
                errors : [],
                msg : ''
            }
        },
       
        components : {
            InputName, InputEmail, ButtonSubmit, ButtonCancel, ErrorList
        },
        methods : {
            checkForm : function (event) {
                this.errors = [];
                
                if (this.name.trim().length <= 0) {
                    this.errors.push(this.$t("validator.name.null"));
                }
                if (!this.email) {
                    this.errors.push(this.$t("validator.email.null"));
                }

                if(validator.hasOnlySpecialCharater(this.name)) {
                    this.errors.push(this.$t("validator.name.special"));
                }

                if(validator.hasNumberCharacter(this.name)) {
                    this.errors.push(this.$t("validator.name.number"));
                }

                if(validator.maxCharacter(this.name) != true) {
                    this.errors.push(this.$t("validator.name.max", {max : validator.maxCharacter(this.name)}));
                }

                if(!validator.validateEmail(this.email) && this.email) {
                    this.errors.push(this.$t("validator.email.example"));
                }

                if(this.msg.trim().length <= 0) {
                    this.errors.push(this.$t("validator.msg.null"));
                }

                if(!this.errors.length) {
                    // this.$parent.initChatOffline(this.name, this.email, this.gender);
                    this.$parent.initChatOfflineV2(this.name, this.email, this.gender, this.msg);
                }

                event.preventDefault()
            },
            getGender : function (event) {
                this.gender = event;
            },

            closeChat : function(event) {
                this.errors = [];
                this.email = '';
                this.name = '';
            },

            cancelButton : function (event) {
                this.email = this.name = this.msg = '';
                this.errors = [];
            },

            checkWhiteSpace : function (event) {
                event.target.value = event.target.value.trimLeft()
            },
        },
        created () {
            EventBus.$on('clearErrorList', this.closeChat);
        }
        
    }
</script>

<style scoped module lang="scss">
    .__register__online {
        width: 100%;
        h5 {
            font-size: 13px !important;
            font-weight: 500 !important;
            line-height: 130% !important;
            margin-bottom: 15px !important;
        }
        .__intro {
            margin-top:1rem !important;
            color:#9A9A9A;
            font-size:13px;
            line-height: 150%;
        }

        .chat__form {
            .__radio, .__email {
                background: #e3e3e3;
                -webkit-border-top-left-radius: 8px;
                -webkit-border-bottom-left-radius: 8px;
                -moz-border-radius-topleft: 8px;
                -moz-border-radius-bottomleft: 8px;
                border-top-left-radius: 8px;
                border-bottom-left-radius: 8px;
                height: 24px;
                border: 1px solid #ccc;
                border-right: 0px;
                width: 100%;
                padding-left: 8px;
                padding-right: 5px;
                padding-top: 1px;
                text-align: left;
            }
            .__radio {
                
                .__radio__custom {
                    display: inline;
                    margin-right:12px;
                    input {
                        &[type="radio"] {
                            position: absolute;
                            opacity: 0;
                        }
                        
                       
                    }
                    input[type="radio"]:checked + label {
                        &:before {
                            background-color: #1AABFF;
                            box-shadow: inset 0 0 0 0px #f4f4f4;
                            border: 1px solid #fff;
                        }
                    }
                    label {
                        margin:0!important;
                        &:before {
                          
                            content: '';
                            background: #f4f4f4;
                            border-radius: 100%;
                            border: 1px solid #b4b4b4;
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            position: relative;
                            top: 3px;
                            margin-right: 4px;
                            vertical-align: top;
                            cursor: pointer;
                            text-align: center;
                            transition: all 250ms ease;
                          
                        }
                        padding-left: 0px;
                        padding-top: 3px;
                        font-size: 12px;
                    }
                }
            }
            .__email {
                line-height: 150%;
                .__icon {
                    font-size: 14px;
                    color:#a7a7a7;
                }
                div {
                    font-size: 12px;
                    display: inline-block;
                    margin-left: 10px;
                    position: absolute;
                    top: 0;
                }
            }
            .__input {
                height: 24px !important;
                border-left: 0px !important;
                padding: 0 10px !important;
                width: calc(100%) !important;
                -webkit-border-radius: 8px !important;
                -webkit-border-top-left-radius: 0px !important;
                -webkit-border-bottom-left-radius: 0px !important;
                -moz-border-radius: 8px !important;
                -moz-border-radius-topleft: 0px !important;
                -moz-border-radius-bottomleft: 0px !important;
                border-radius: 8px !important;
                border-top-left-radius: 0px !important;
                border-bottom-left-radius: 0px !important;
                font-size: 12px !important;
            }

          
            
        }
    }

  
    @media screen and (min-width: 769px) {
        .__register__online {
            h5 {
                font-size: 13px !important;
            }
            .__intro {
                font-size: 10px;
            }
        }
    }
</style>
<style lang="scss">
    .bdr-radius {
        background: #FCFCFC;
        border: 1px solid #E5E5E5;
        box-sizing: border-box;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        margin-top: 10px;
        .input-comment {
            padding: 5px 15px 0;
            position: relative;
            height: 70px;
            .textarea {
                border: 0px;
                width: 100%;
                outline: none;
                resize: none !important;
                line-height: 19px !important;
                font-size: 12px !important;
                background: none;
            }
        }
        .footer {
            width: calc(100% - 30px);
            width: 100%;
            height: 32px;
            display: table;
            padding: 0 15px 10px;
            
            div {
                display: table-cell;
                vertical-align: middle;
                width: 34px;
                &:last-child{
                    width: auto;
                    text-align: right;
                    margin-right: 15px;
                }
                .ico-camera, .ico-settings {
                    font-size: 20px !important;
                }
                a.material-icons {
                    color: #c7ccd1 !important;
                    padding-top: 3px;
                    text-decoration: none !important;
                    
                }
            }
        }
    }
</style>